import React, { useState } from 'react'
import Separator from '../../common/separator';
import { ProjectData } from '../../data/projects'
import ProjectCard from './project-card';
import './projects.css'


function Projects() {
    const data = ProjectData;
    const [type,setType] = useState("fullstack");

    function changeType(e) {

        if(e.target.textContent == "Fullstack") {
            setType("fullstack");
        }
        else if (e.target.textContent == "AI & ML") {
            setType("ml");
        }
        else if (e.target.textContent == "Chatbot") {
            setType("chatbot");
        }
        else if (e.target.textContent == "Gaming") {
            setType("gaming");
        }
        else if (e.target.textContent == "Other") {
            setType("other");
        }
    }

    return (
        <div className='projects'>
        <Separator/>
        <label className='section-title'>Projects</label>
        <div>
            <button className='select-button' onClick={changeType}>Fullstack</button>
            <button className='select-button' onClick={changeType}>AI & ML</button>
            <button className='select-button' onClick={changeType}>Chatbot</button>
            <button className='select-button' onClick={changeType}>Gaming</button>
            <button className='select-button' onClick={changeType}>Other</button>
        </div>
        <div>
            {data.filter((project)=>project.type.includes(type)).reverse().map((filtered_project) => {
                return <ProjectCard key={filtered_project.id} project={filtered_project}/>
            })}
        </div>
        </div>
    )
}

export default Projects
